const tabcordionComp = (data, ScrollTrigger, smoother, gsap) => {
    
  const initialQuery = window.matchMedia('(max-width: 40rem)')
  const mediaQuery = window.matchMedia('(max-width: 40rem)');
  const $component = $('.comp__tabcordion');
  const $boxes = $('.title-box');
  const $expandContent = $('.capability-expand');
  
  if ($component.length) {
    
    if (initialQuery.matches) {
      // Screens below 768px
      $('.title-box:nth-child(1)').find('.accordion-box').addClass('active');

    } else {
      // Screens 768px and above
      $('.capability-expand:nth-child(1)').addClass('active');

    }

    function handleTabletChange(e) {

      if (e.matches) {
        // Screens below 768px

        $boxes.find('button').addClass('mobile');

        $boxes.each(function() {

          const $this = $(this);
          const $mobileBox = $this.find('.accordion-box');
          const $id = $this.find('button').data('capability');
          const $content = $('#' + $id).find('.content');

          if ($mobileBox.children().length == 0) {

            $($content).detach().appendTo($mobileBox);

          }

        });

      } else {
        // Screens 768px and above

        $boxes.find('button').removeClass('mobile');

        $expandContent.each(function() {

          const $this = $(this);
          const $id = $this.attr('id');
          const $content = $('*[data-capability="'+$id+'"]').parent().find('.content');

          if ($this.children().length == 0) {
            $this.append($content);
          }

        });

      }
    }

    // Register event listener
    mediaQuery.addListener(handleTabletChange);

    // Initial check
    handleTabletChange(mediaQuery);

    const $buttons = $('.title-box button');

    $buttons.each(function() {

      const $this = $(this);
      const $class = $this.data('capability');
      const $content = $('.' + $class);
      const $mobileExpand = $this.parent().find('.accordion-box');
      const $desktopExpand = $('.content-expand .' + $class);

      $(this).on('click', function() {

        // If clicking the tab that is already open on desktop
        if ($this.hasClass('active') && !$this.hasClass('mobile')) {

          $this.removeClass('active');
          $component.find('.content-expand').slideUp(300, function() {
            $(this).attr('style', '');
            $component.find('.content').parent().hide(0, function() {
              $(this).add($desktopExpand).removeClass('active').attr('style', '');
            });
            ScrollTrigger.refresh(true);
          });

        } else if ($this.hasClass('active') && $this.hasClass('mobile')) {
          // If clicking the tab that is already open on mobile
          $this.removeClass('active');
          $component.find('.content').parent().slideUp(300, function() {
            $(this).attr('style', '').removeClass('active');
            $component.find('.content-expand').hide(0, function() {
              $(this).add($desktopExpand).removeClass('active').attr('style', '');
            });
            ScrollTrigger.refresh(true);
          });
        }
        // Just clicking through the tabs
        else {

          // Clicking through desktop tabs
          if ($component.find('.content').parent().is(':visible') && !$this.hasClass('mobile')) {

            let h = $component.find('.content:visible').parent().outerHeight();

            $component.find('.content-expand').css({
              height: h
            });

            $('.title-box button').css('pointer-events', 'none');

            $component.find('.content').parent().not($content).fadeOut(400, function() {
              const $not = $('.capability-expand').not($desktopExpand);
              $('.title-box button').not($this).removeClass('active');
              $(this).removeClass('active');
              $this.addClass('active');
              setTimeout(() => {
                $component.find('.accordion-box').add($not).attr('style', '').removeClass('active');
                $desktopExpand.fadeIn(400, function() {
                  $component.find('.content-expand').animate({
                    height: $desktopExpand.find('.content').outerHeight()
                  }, 100);
                  $content.addClass('active');
                  $('.title-box button').css('pointer-events', 'auto');
                });
              }, 100);
            });

          } 
          // Clicking through mobile accordion tabs
          else if ( $('.content').parent().is(':visible') && $this.hasClass('mobile') ) {

            $component.find('.content').parent().not($content).slideUp(400, function() {
              const $not = $component.find('.accordion-box').not($mobileExpand);
              $('.title-box button').not($this).removeClass('active');
              $(this).removeClass('active');
              $this.addClass('active');
              setTimeout(() => {
                $not.add('.capability-expand').removeClass('active').attr('style', '');
                $mobileExpand.slideDown(400, function() {
                  $content.addClass('active');
                  ScrollTrigger.refresh(true);
                  setTimeout(() => {
                    gsap.to(smoother, {
                      scrollTop: smoother.offset($this, "top 100px"),
                      duration: 0.6,
                    });
                  }, 100);
                });
              }, 400);
            });

          } 
          // Reopening accordion tabs
          else if ( $component.find('.content').parent().is(':hidden') && $this.hasClass('mobile') ) {

            $this.addClass('active');
            setTimeout(() => {
              $mobileExpand.slideDown(400, function() {
                $content.addClass('active');
                ScrollTrigger.refresh(true);
              });
            }, 400);

          } 
          // Reopening desktop tabs
          else if ( $component.find('.content').parent().is(':hidden') && !$this.hasClass('mobile') ) {

            $this.addClass('active');
            setTimeout(() => {
              $desktopExpand.slideDown(400, function() {
                $content.addClass('active');
              });
            }, 400);

          }

        }

      });

    });
    
  }
  
}

export {
  tabcordionComp
};
